import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Board extends Model {
  resource() {
    return 'boards'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .format('DD/MMM/YYYY')
      .toUpperCase()
  }

  get dateUpdated() {
    return dayjs.utc(this.updated_at).format('DD MMMM YYYY')
  }
}
